import React from 'react';

import styles from './styles';

interface ProgressProps {
  progress: number;
}

const Progress: React.FC<ProgressProps> = (props) => {
  return (
    <div className={styles.container}>
      <div className={styles.progressBar} style={{ width: `${props.progress}%` }} />
    </div>
  );
};

export default Progress;
